export default {
  configurations (state) {
    return state.configurations
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/configurations/getters.js